//GeneratorFlag:[NoChange]
import { Server } from '@/core/server'
export default class PersonGenderService
{
	constructor(){}

	server(config)
	{
		return new Server(config)
	}

	//GeneratorFlag:[PersonGender.Detail]
	async detail(params, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = false;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		return await _server.get('/hub/person-gender/detail', {'params':params});
	};

	//GeneratorFlag:[PersonGender.List]
	async list(params, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = false;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		return await _server.get('/hub/person-gender/list', {'params':params});
	};

//GeneratorFlag:[NewAction]
}